export const SortCode = ( {
    sortCode, setSortCode
} ) => {
    return (
        <>
            <p className="form-row form-row-wide">
				<label htmlFor="tfa_enc-sort-code">Sort code&nbsp;<span className="required">*</span></label>
				<input id="tfa_enc-sort-code"
                    className="input-text tfa_enc-form-sort-code" 
                    required  
                    type="tel" 
                    name="tfa_enc-sort-code" 
                    onChange={(e) => {
                        console.log('sortcode change', e.target.value);setSortCode(e.target.value)}}
                    value={sortCode}
                />
			</p>
        </>
    )
}

export const AccountNumber = ( {
    accountNumber, setAccountNumber
} ) => {
    return (
        <>
            <p className="form-row form-row-wide">
				<label htmlFor="tfa_enc-account-number">Account number&nbsp;<span className="required">*</span></label>
				<input id="tfa_enc-account-number"
                    className="input-text tfa_enc-form-account-number"
                    required  
                    type="tel" 
                    name="tfa_enc-account-number" 
                    onChange={(e) => {
                        console.log('accountnumberchange', e.target.value);setAccountNumber(e.target.value)}}
                    value={accountNumber}
                />
			</p>
        </>
    )
}

export const BBName = ( {
    bbName, setBBName
} ) => {
    return (
        <>
            <p className="form-row form-row-wide">
				<label htmlFor="tfa_enc-bbname">Bank/Building Society name&nbsp;<span className="required">*</span></label>
				<input id="tfa_enc-bbname"
                    className="input-text tfa_enc-form-bbname"
                    required  
                    type="text" 
                    name="tfa_enc-bbname" 
                    onChange={(e) => {console.log('bbname change', e.target.value);setBBName(e.target.value)}}
                    value={bbName}
                />
			</p>
        </>
    )
}

export const AccountHolder = ( {
    accountHolder, setAccountHolder
} ) => {
    return (
        <>
            <p className="form-row form-row-wide">
				<label htmlFor="tfa_enc-accountHolder">Name(s) of Account Holder(s)&nbsp;<span className="required">*</span></label>
				<input id="tfa_enc-accountHolder"
                    className="input-text tfa_enc-form-accountHolder"
                    required  
                    type="text" 
                    name="tfa_enc-accountHolder" 
                    onChange={(e) => {
                        console.log('account holder change', e.target.value);setAccountHolder(e.target.value)}}
                    value={accountHolder}
                />
			</p>
        </>
    )
}